import {
    Pipe,
    PipeTransform,
} from "@angular/core";
import { UserBalance } from "@Front-end/seed/utils/interfaces";

@Pipe({
    name: "sumBalance",
    pure: true,
    standalone: true,
})
export class SumBalancePipe implements PipeTransform {

    public transform(balance: Partial<UserBalance>): number {
        const bonusBalance: number = balance.bonus_sport ? (balance.bonus_sport || 0) : balance.bonus || 0;
        return (balance.balance || 0) + (bonusBalance || 0);
    }

}
